import type { ResponsiveValue } from "@chakra-ui/react";
import { Text } from "@chakra-ui/react";
import React from "react";
import { colours } from "@shared/ui.design-system";
import { ProductLink } from "packages/basket-and-checkout/shared/components/ProductLink/ProductLink";
import type { ItemClickBehaviour } from "@shared/graphql.types";

type Props = {
  displayOption: ResponsiveValue<"inline" | "block">;
  titleColor?: string;
  descColor?: string;
  itemClickBehaviour?: ItemClickBehaviour;
  source?: "HCL" | "CT";
  onProductClick?: () => void;
  pdpUrlLink;
  titles: {
    brandName?: string;
    title?: string;
    subTitle?: string;
  };
  descriptionVariant;
};

export const DescriptionLinksWrapper = ({
  displayOption,
  titleColor,
  itemClickBehaviour,
  source,
  onProductClick,
  pdpUrlLink,
  titles: { brandName, title, subTitle },
  descriptionVariant,
  descColor
}: Props) => {
  const isHCL = source === "HCL";

  const customClickBehaviour = itemClickBehaviour != "LINK";

  return (
    <>
      <Text
        variant="acuminMedium"
        mt="0"
        display={displayOption}
        onClick={customClickBehaviour ? onProductClick : undefined}
        {...(titleColor ? { color: titleColor } : {})}
      >
        <ProductLink
          variant="acuminMedium"
          dataTestId="brand-name-link"
          pdpUrl={
            pdpUrlLink && !isHCL && !customClickBehaviour
              ? pdpUrlLink
              : undefined
          }
        >
          {brandName}
        </ProductLink>
      </Text>
      <Text
        color={descColor || colours.primary.dark}
        marginTop="0"
        marginBottom="5px"
        variant={descriptionVariant}
        wordBreak="break-word"
        display={displayOption}
        onClick={customClickBehaviour ? onProductClick : undefined}
      >
        <ProductLink
          dataTestId="title-link"
          pdpUrl={
            pdpUrlLink && !brandName && !customClickBehaviour
              ? pdpUrlLink
              : undefined
          }
        >
          {title}
        </ProductLink>
      </Text>
      <Text
        color={descColor || colours.primary.dark}
        marginTop="0"
        marginBottom="5px"
        variant={descriptionVariant}
        wordBreak="break-word"
        display={displayOption}
        onClick={customClickBehaviour ? onProductClick : undefined}
      >
        <ProductLink
          dataTestId="subtitle-link"
          pdpUrl={
            pdpUrlLink &&
            !brandName &&
            !title &&
            subTitle &&
            !customClickBehaviour
              ? pdpUrlLink
              : undefined
          }
        >
          {subTitle}
        </ProductLink>
      </Text>
    </>
  );
};
